<template>
  <div class="width100p">
    <v-card class="titlebar mb-4 width100p" flat :loading="loading">
      <v-card-text class="py-2">
        <div class="d-flex flex-row flex-wrap justify-space-between">
          <div class="d-flex flex-column">
            <div class="text-h4">
              {{ searchForPower ? "CL Power" : "Refraction" }} Search
            </div>
            <div v-if="meta && meta.search.term" class="mt-2">
              Contacts lens names like <i>'{{ meta.search.term }}'</i>
            </div>

            <div class="d-flex flex-row flex-wrap align-start my-2">
              <!-- <div class="overline">Filters</div> -->
              <v-text-field
                clearable
                dense
                v-model="filters.name"
                label="Filter by name"
                hide-details="auto"
                class="compact-select mb-1 mr-4"
                width="150"
                v-if="pairs && pairs.length > 3"
              ></v-text-field>
              <v-checkbox
                class="mt-1 mr-6"
                v-model="filters.high_dk"
                label="Only high dk"
                v-if="pairs && pairs.length > 3"
              ></v-checkbox>
              <replace-select
                v-if="pairs && pairs.length > 3"
                class="mr-4"
                style="margin-top: 8px"
                @replace="setFilterValue('replace', $event)"
                :external="filters.replace"
                :options="replaceOptionsForSet"
                :canBeBig="true"
              ></replace-select>
            </div>
          </div>

          <div class="d-flex flex-column">
            <div class="d-flex flex-column">
              <div class="d-flex flex-row flex-wrap" v-if="eyeRxCount == 2">
                <!-- <div class="overline pt-2 mr-2">Group/Sort by:</div> -->
                <div style="width: 200px" class="text-center">
                  <v-select
                    v-model="groupBy"
                    @change="briefLoading()"
                    :items="groupByItems"
                    item-value="value"
                    item-text="label"
                    dense
                    outlined
                    rounded
                    solo
                    flat
                    class="compact-select"
                    :hide-details="true"
                  ></v-select
                  ><v-btn
                    v-if="groupBy == 'company'"
                    depressed
                    @click="toggleExpandAllCompanies()"
                    x-small
                    outlined
                    color="primary"
                    rounded
                    width="120"
                    class="my-2 ml-8"
                    >{{ hideAllCompanies ? "Expand" : "Collapse" }} All
                    <v-icon x-small class="mr-4"
                      >mdi-{{
                        hideAllCompanies ? "arrow-expand" : "arrow-collapse"
                      }}
                    </v-icon></v-btn
                  >
                </div>
              </div>
              <v-checkbox
                v-model="showAnnualPrices"
                label="Show Prices"
                dense
                hide-details="auto"
                class="pa-0 my-2 my-sm-0 mx-1"
              ></v-checkbox>
              <div v-if="eyeRxCount == 1">
                <!-- this is just for when results for one eye -->
                <v-checkbox
                  v-model="groupByCompany"
                  label="Group by Company"
                ></v-checkbox>
              </div>

              <!-- <div class="text-right">
                
              </div> -->
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <v-container class="py-0 my-4" v-if="rxObjects">
      <v-row no-gutters align="center">
        <v-col cols="12" md="4" sm="6" class="my-4 my-sm-0">
          <edit-power-criteria
            v-if="meta && meta.search"
            :currentCriteria="meta.search"
            :initialRxObjects="rxObjects"
          ></edit-power-criteria>
        </v-col>
        <v-col no-gutters>
          <rx-summary-card-pair
            :rxs="rxObjects"
            :showCrosses="eyeRxCount == 1"
            :dontVertex="searchForPower"
          >
          </rx-summary-card-pair>
        </v-col>
      </v-row>
    </v-container>

    <v-fade-transition>
      <div v-if="!loading && filteredPairs && filteredPairs.length > 0">
        <div v-if="eyeRxCount == 2">
          <div
            v-for="(itemArr, index) in pairsForOrder"
            :key="index"
            :class="
              !groupBy == 'company' ||
              (itemArr.id && !hideCompanies.includes(itemArr.id))
                ? 'mb-8'
                : ''
            "
          >
            <div
              v-if="groupBy == 'company'"
              class="headerDiv d-flex flex-row align-center"
              :style="
                hideCompanies.includes(itemArr.id) ? 'margin-bottom:-1px' : ''
              "
              @click="toggleHideCompanies(itemArr.id)"
            >
              <!-- {{ itemArr.id }} -->
              <product-image
                :companyId="itemArr.id"
                type="companyId"
                :maxWidth="200"
                :maxHeight="40"
                classes="ma-1"
              />
              <v-spacer></v-spacer>
              <v-btn icon>
                <v-icon>{{
                  hideCompanies.includes(itemArr.id)
                    ? "mdi-chevron-down"
                    : "mdi-chevron-up"
                }}</v-icon>
              </v-btn>
            </div>
            <v-expand-transition>
              <div
                v-if="
                  !groupBy == 'company' || !hideCompanies.includes(itemArr.id)
                "
              >
                <lens-pair-row
                  v-for="pairIndex in itemArr.items"
                  :lensPair="pairs[parseInt(pairIndex)]"
                  :key="pairIndex"
                  :rxHash="theRxHash"
                  :externalExpand="expand"
                  :showAnnualPrices="showAnnualPrices"
                  :hideCompanies="groupBy == 'company'"
                  class="mt-1"
                />
                <!-- :oneEye="!hasOsRx"-->
              </div>
            </v-expand-transition>
          </div>
        </div>
        <div v-else-if="oneEyeLenses">
          <!-- todo - separate this table out and consolidate it with the other CL tables (SoftClTable) -->

          <soft-cl-table
            :items="oneEyeLenses"
            :groupBy="groupByCompany ? 'company' : null"
            :showAnnualPrices="showAnnualPrices"
            tableType="power"
            @lensSelected="handleTableClick($event)"
            sortBy="vaString"
          ></soft-cl-table>
        </div>
        <soft-disclaimers class="mt-6"></soft-disclaimers>
      </div>
      <v-alert
        v-if="!loading && filteredPairs && filteredPairs.length == 0"
        prominent
        color="#ffe5bf"
        :border="'left'"
        transition="scale-transition"
        class="mx-1 my-8"
        icon="mdi-alert"
      >
        There are no results. Consider altering your search requirements and/or
        filters.
        <ul>
          <li v-if="filters.replace != 'ALL'">
            Replacement: {{ filters.replace | titleize }}
            <v-btn @click="filters.replace = 'ALL'" x-small text color="red"
              ><v-icon small color="red" class="mr-1">mdi-minus-circle</v-icon
              >remove filter</v-btn
            >
          </li>
          <li v-if="filters.name && filters.name != ''">
            Name: {{ filters.name }}
            <v-btn @click="filters.name = ''" x-small text color="red"
              ><v-icon small color="red" class="mr-1">mdi-minus-circle</v-icon>
              remove filter</v-btn
            >
          </li>
          <li v-if="limitedCompanies">
            Consider expanding your search to include all companies
            <v-btn @click="searchWithoutCompanies()" text small color="red"
              ><v-icon small color="red" class="mr-1">mdi-open-in-new</v-icon>
              do it</v-btn
            >
          </li>
        </ul>
      </v-alert>
    </v-fade-transition>

    <v-alert
      v-if="meta && !loading && !pairs"
      class="mx-4 my-4"
      color="orange lighten-4"
      icon="mdi-alert"
    >
      <div><b>No lenses found</b></div>
      <div class="my-2">
        From your refraction and search criteria, we are trying to find lenses
        with these attributes:
      </div>
      <div class="ma-2">
        A
        <span v-if="meta.search.toric.od == 1" class="font-weight-bold"
          >toric
        </span>
        <span v-if="meta.search.bifocal == 1" class="font-weight-bold"
          >bifocal
        </span>
        <span v-if="meta.search.cosmetic == 1" class="font-weight-bold"
          >cosmetic
        </span>
        lens
        <span v-if="meta.search.term != ''">
          whose name is like '<b>{{ meta.search.term }}</b
          >'
        </span>
      </div>
      <div class="mt-4 font-italic">
        If this is not correct
        <span v-if="meta.search.bifocal == 1">
          (for example, were you really wanting a bifocal?)
        </span>
        try editing the CURRENT SEARCH CRITERIA above.
      </div></v-alert
    >
  </div>
</template>

<script>
// import LensPairRow from "@/components/clStuff/LensPairRow";
import FilterDictionary from "@/assets/js/cls/FilterDictionary";
import FiltersMixin from "@/assets/js/cls/FiltersMixin";
import ApiServices from "@/services/ApiServices";
// import HashParserMixin from "@/assets/js/HashParserMixin";
import RxMethods from "@/assets/js/cls/RxMethods";
import ClCompanyMixin from "@/assets/js/cls/ClCompanyMixin";
import ReplaceSelect from "@/components/clStuff/ReplaceSelect";
// import LensPairRow from "@/components/clStuff/LensPairRow";
import RxSummaryCardPair from "@/components/clStuff/RxSummaryCardPair";
import EditPowerCriteria from "@/components/clStuff/EditPowerCriteria";
import StyleUtilities from "@/assets/js/StyleUtilities";

export default {
  name: "SoftPowerResultTable",
  components: {
    ReplaceSelect,
    RxSummaryCardPair,
    EditPowerCriteria,
    LensPairRow: () => import("@/components/clStuff/LensPairRow"),
    ProductImage: () => import("@/components/clStuff/ProductImage"),
    // SoftTypeIcon: () => import("@/components/clStuff/SoftTypeIcon"),
    SoftDisclaimers: () => import("@/components/clStuff/SoftDisclaimers"),
    SoftClTable: () => import("@/components/clStuff/SoftClTable"),
  },
  mixins: [
    FilterDictionary,
    ClCompanyMixin,
    RxMethods,
    FiltersMixin,
    StyleUtilities,
  ],
  props: {},
  data: function () {
    return {
      pairs: null,
      // name: null,
      meta: null,
      filters: { ...FilterDictionary.filterDefaults },
      filterDefaults: { ...FilterDictionary.filterDefaults },
      expand: false,
      hideAllCompanies: false,
      loading: true,
      rxObjects: null,
      groupBy: "score",
      showAnnualPrices: true,
      searchForPower: null,
      limitedCompanies: true,
      groupByCompany: null, // just for when results for one eye (when 2 eyes uses groupByItems options)
      hideCompanies: [],
      groupByItems: [
        // if lenses for both eyes
        { label: "Group By Company", value: "company" },
        { label: "Sort By OU VA", value: "score" },
        { label: "Sort By OD VA", value: "va_od" },
        { label: "Sort By OS VA", value: "va_os" },
      ],
    };
  },
  methods: {
    doSearch() {
      // console.log("noCompanyFilter", noCompanyFilter);
      // todo - do some error checking on the hash
      let paramString = window.location.hash.substring(1);
      if (this.hashHasAdd()) paramString += "&bifocal=1";
      let hasCompany = this.hashHasCompany();
      if (!hasCompany) {
        paramString += "&comp_id[]=1,2,4,8";
      }
      if (this.$route.query.q) {
        paramString += "&term=" + this.$route.query.q;
      }

      ApiServices.lensPowerSearchAPI(paramString)
        .then((response) => {
          this.pairs = response.data.pairs;
          this.meta = response.data.meta;
          if (this.meta.vertex === 0) this.searchForPower = true;

          // console.log(response.data);
          //this.companiesLoaded = this.selectedCompanyIds;
          this.loading = false;
        })
        .catch((e) => {
          // alert(e);
          this.loading = false;
          console.log("axios error: " + e); // todo - make this a data and display it
        });
    },
    searchWithoutCompanies() {
      this.replaceCompanyInHash("ALL");
      this.doSearch();
      // call the API
      // this.$router.push({ path: "/cls/rx/" + newParams });
    },
    toggleHideCompanies(id) {
      const index = this.hideCompanies.indexOf(id);
      if (index > -1) {
        // only splice array when item is found
        this.hideCompanies.splice(index, 1); // 2nd parameter means remove one item only
      } else {
        this.hideCompanies.push(id);
      }
    },
    toggleExpandAllCompanies() {
      this.hideAllCompanies = !this.hideAllCompanies;
      this.hideCompanies = this.hideAllCompanies ? this.allCompanyIds : [];
    },
    briefLoading() {
      const that = this;
      that.loading = true;
      setTimeout(function () {
        that.loading = false;
      }, 1500);
    },
    handleTableClick(lensObj) {
      this.$router.push({
        path: `/cls/details/${lensObj.slug}#${this.theRxHash}`,
      });
    },
  },
  computed: {
    allCompanyIds: function () {
      if (!this.meta) return null;
      let idStrings = Object.keys(this.meta.byCompany);
      let ids = idStrings.map(function (x) {
        return parseInt(x, 10);
      });
      return ids;
    },
    theRxHash: function () {
      // make a hash based on the Rxs (this will be used to make links to details pages that include the Rx )
      return this.rxHashOU(this.rxObjects);
    },
    // returns in this format:
    // [{id:X, items:[i1,i2,i3]},{...}]
    // this id will be a company id when grouping by company, otherwise will ne null
    // the items (i1,i2) are indices from this.pairs
    pairsForOrder: function () {
      if (!this.pairs) return null;
      let rtn = [];
      let orderBy = this.groupBy;
      if (orderBy == "company") {
        rtn = this.orderByCompany;
      } else {
        let items = [];
        if (orderBy == "score") items = this.orderByScores;
        if (orderBy == "va_od") items = this.orderByVA.od;
        if (orderBy == "va_os") items = this.orderByVA.os;

        rtn = [{ id: null, items: items }];
      }

      return rtn;
    },
    // if the search was only for one eye, make an array of lenses for that eye
    oneEyeLenses: function () {
      if (!this.eyeRxCount == 1 && !this.pairs) return null;
      let rtn = [];
      this.filteredPairs.forEach((pairRowId) => {
        const row = this.pairs[pairRowId];
        // console.log(row);
        let obj = row.od; // if one eye always defaults to OD. Change this?
        obj.rx = obj.bestRx?.string;
        obj.company = row.company;
        obj.dk = row.dk;
        obj.company_id = parseInt(row.company_id);
        obj.replace = row.replace;
        rtn.push(obj);
      });
      return rtn;
    },
    orderByScores: function () {
      if (!this.filteredPairs) return null;
      let rtn = [];
      this.meta.byScores.forEach((id) => {
        if (this.filteredPairs.includes(id)) rtn.push(id);
      });
      return rtn;
    },
    orderByVA: function () {
      if (!this.filteredPairs) return null;
      let rtn = { od: [], os: [] };
      this.meta.byVA_od.forEach((id) => {
        if (this.filteredPairs.includes(id)) rtn.od.push(id);
      });
      this.meta.byVA_os.forEach((id) => {
        if (this.filteredPairs.includes(id)) rtn.os.push(id);
      });
      return rtn;
    },
    // orderByScore: function () {},
    orderByCompany: function () {
      if (!this.pairs || !this.logicalCompanyOrder) return null;
      let f = this.filteredPairs;
      let lensesByComp = this.meta.byCompany;
      let companyOrder = this.logicalCompanyOrder;
      let rtn = [];
      // console.log("companyOrder", companyOrder);
      // console.log("lensesByComp", lensesByComp);
      companyOrder.forEach((compId) => {
        // console.log("compId", compId);
        let lensesForComp = lensesByComp[compId];
        if (Array.isArray(lensesForComp)) {
          let temp = [];
          lensesForComp.forEach((rowIndex) => {
            // console.log(compId, ":", rowIndex);
            if (f.includes(rowIndex)) temp.push(rowIndex);
          });
          if (temp.length) rtn.push({ id: compId, items: temp });
        }
      });
      return rtn;
    },

    filteredPairs: function () {
      // todo - return the whole lenses array if filters is an empty object
      if (!this.meta?.byScores) return null;
      let f = this.filters;
      if (!f) return this.pairs;
      let replaceFilter = FilterDictionary.daysArrayForReplacementKey(
        f.replace
      );
      // console.log("replaceFilter:");
      // console.log(replaceFilter);

      return this.meta.byScores.filter((index) => {
        let item = this.pairs[index];
        // console.log("index", index);
        let include = true;
        // console.log("dk",parseFloat(item.od.dk));
        if (f.high_dk && parseFloat(item.od.dk) < 45) return false;

        // search for name and company name match
        if (!item || !item.name) return false;
        if (f.name && f.name != "") {
          let nameMatch =
            item.name.toLowerCase().indexOf(f.name.toLowerCase()) != -1;
          let companyMatch =
            item.company.toLowerCase().indexOf(f.name.toLowerCase()) != -1;
          include = nameMatch || companyMatch;
        }
        // check for replacement match
        let lensDays = parseInt(item.replace);

        if (Array.isArray(replaceFilter) && replaceFilter.length > 0) {
          let replaceMatch = replaceFilter.includes(lensDays);
          include = include && replaceMatch; // && companyIdMatch;
        }

        return include;
      });
    },
    replaceOptionsForSet: function () {
      if (!this.meta) return null;
      return this.meta.replacements;
    },
    eyeRxCount: function () {
      let eyes = 0;
      if (this.rxObjects?.od) eyes++;
      if (this.rxObjects?.os) eyes++;
      return eyes;
    },
  },
  watch: {
    showAnnualPrices(val) {
      localStorage.setItem("showAnnualPrices", val);
    },
  },
  mounted() {
    if (this.hashHasCompany) this.limitedCompanies = true;
    this.doSearch();
    let hashParts = this.hashParts();
    // console.log("hashParts", hashParts);
    if (hashParts && hashParts["searchForPower"]) this.searchForPower = true;
    // if (hashParts && hashParts["q"]) this.searchRxText(hashParts["q"]);
    let rxObjects = this.rxsFromHash(hashParts); // extract the rxs from the hash
    this.rxObjects = rxObjects;
    this.setFiltersFromHash();
    if (localStorage.getItem("showAnnualPrices"))
      this.showAnnualPrices =
        localStorage.getItem("showAnnualPrices") == "true";
  },
  metaInfo() {
    return {
      title: "EyeDock/CLs | Search By Rx",
    };
  },
};
</script>

<style scoped>
.titlebar {
  /* border: 1px solid #cedae3 !important;
  background-image: linear-gradient(136deg, #e9f2f9 40%, #e3f2fd); */
  border: 1px solid #a4bdd0 !important;
  background-image: linear-gradient(177deg, #e2f2ff 40%, #aadbff);
}

.headerDiv {
  padding: 5px;
  border-radius: 3px;
  background-color: #f5fafe;
  border: 1px solid #c7ddf9;
  padding-left: 1.5em;
  min-height: 54px;
  cursor: pointer;
}
</style>
